import React from 'react';
import { ButtonLink, OverviewHeader, Icon } from '@brighterion/br-ui';
import { OverviewContainer } from './OverviewContainer';
import type { OverviewContainerProps } from './OverviewContainer';

import styles from './Overview.css';

type OverviewProps = Omit<React.ComponentProps<typeof OverviewHeader>, 'children'> & {
    onButtonLinkClick?: React.ComponentProps<typeof ButtonLink>['clickCb'];
} & OverviewContainerProps;
const Overview = ({
    leftTitle,
    rightTitle,
    onButtonLinkClick,
    leftData,
    leftContainerClassName,
    rightData,
    dataTestId,
    boldedText = true,
    children,
    deployment
}: OverviewProps) => (
    <OverviewHeader
        dataTestId={dataTestId}
        leftTitle={leftTitle}
        rightTitle={
            rightTitle ??
            (onButtonLinkClick && (
                <button
                    data-testid='overview-btn'
                    type='button'
                    className={styles.editButton}
                    onClick={onButtonLinkClick}
                >
                    <Icon name='pencil-1' size='md' aria-label='pencil-1' className={styles.editIcon} />
                </button>
            ))
        }
        containerClassName={styles.overviewHeader}
    >
        <OverviewContainer
            boldedText={boldedText}
            dataTestId={dataTestId}
            deployment={deployment}
            leftContainerClassName={leftContainerClassName}
            leftData={leftData}
            leftTitle={leftTitle}
            rightData={rightData}
        >
            {children}
        </OverviewContainer>
    </OverviewHeader>
);

export default Overview;
